import { Component, Input } from '@angular/core';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-copy',
  templateUrl: './copy.component.html',
  styleUrls: ['./copy.component.scss'],
})
export class CopyComponent {

  @Input() value: string|number;
  @Input() label: string;

  constructor(
    private toastCtrl: ToastController,
  ) { }

  copy($event) {
    // Stop the event from propagating
    $event.stopPropagation();
    this.toastCtrl.create({
      message: 'La valeur a bien été copiée dans le presse-papier',
      color: 'success',
      duration: 2000,
    }).then(toast => toast.present());
    navigator.clipboard.writeText('' + this.value);
  }
}
